import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Partner from "@/pages/Partner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Resources from "@/components/Resources";
import Chapters from "@/components/Chapters";
import Faq from "@/components/Faq";
import BudgetTool from "@/components/BudgetTool";
import DebtTool from "@/components/DebtTool";
import AiAdvisor from "@/components/AiAdvisor";
import Footer from "@/components/Footer";
import { setLenis } from "@/lib/scroll";

function Landing() {
  useEffect(() => {
    if (!sessionStorage.getItem("gv-pv")) {
      sessionStorage.setItem("gv-pv", "1");
      fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type: "pageview" }),
      }).catch(() => {});
    }
  }, []);

  return (
    <div className="min-h-screen bg-background text-foreground antialiased">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Resources />
        <Chapters />
        <Faq />
        <BudgetTool />
        <DebtTool />
        <AiAdvisor />
      </main>
      <Footer />
    </div>
  );
}

export default function App() {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenis.scrollTo(0, { immediate: true });
    setLenis(lenis);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      setLenis(null);
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/personvern" element={<Privacy />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Toaster position="bottom-center" richColors />
    </BrowserRouter>
  );
}
